import NewSopForm, { useNewSopFormData } from 'components/NewSopForm';
import React, { useEffect, useState } from 'react';
import { formatType, getPath } from 'utils/entity.utils';

import { Dialog } from '@acheloisbiosoftware/absui.core';
import { ENTITY_SOP } from 'constants/schemas';
import PropTypes from 'prop-types';
import { getGenericId } from 'utils/generic.utils';
import { sopActions } from 'store/entity';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

function NewSopDialog(props) {
  const { open, onClose, initState } = props;
  const {
    formData,
    valid,
    resetFormData,
    updateFormData,
  } = useNewSopFormData(initState);

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (open) resetFormData();
  }, [open, resetFormData]);

  const _onClose = () => {
    resetFormData();
    onClose();
  };

  const onConfirm = () => {
    setLoading(true);
    dispatch(sopActions.createSop(formData))
      .unwrap()
      .then((res) => {
        _onClose();
        navigate(getPath(getGenericId(res.result, ENTITY_SOP)));
      })
      .finally(() => setLoading(false));
  };

  return (
    <Dialog
      title={`New ${formatType(ENTITY_SOP, { template: formData?.is_template })}`}
      open={open}
      onClose={_onClose}
      confirmButtonText='Create'
      disableCloseOnConfirm
      confirmDisabled={!valid}
      onConfirm={onConfirm}
      loading={loading}
      confirmButtonProps={{ 'data-test': 'SOP-create' }}
      fullWidth
      maxWidth='xs'
    >
      <NewSopForm
        formData={formData}
        updateFormData={updateFormData}
      />
    </Dialog>
  );
}

NewSopDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  initState: PropTypes.object,
};

export default NewSopDialog;
